import React from 'react';

export default function AdminCatalogTop({
  catalogDbActive,
  adminUsername,
  onLogout,
  onPublishCatalog,
  saving,
  dirty,
  dataSource,
  loading,
}) {
  const showOffline = !loading && !catalogDbActive && dataSource !== 'mysql';

  let statusTone = 'ok';
  let statusLabel = 'Synced';
  if (saving) {
    statusTone = 'busy';
    statusLabel = 'Saving';
  } else if (dirty) {
    statusTone = 'pending';
    statusLabel = 'Pending';
  } else if (showOffline) {
    statusTone = 'warn';
    statusLabel = 'Offline';
  } else if (catalogDbActive) {
    statusLabel = 'Live';
  }

  return (
    <div className="admin-shell-top">
      <div className="admin-shell-top__row">
        <div className="admin-shell-top__brand">
          <span className="admin-shell-top__kicker">Saloni Designs</span>
          <h1 className="admin-shell-top__title">Store admin</h1>
        </div>

        <div className="admin-shell-top__tools">
          <span
            className={`admin-shell-top__pill admin-shell-top__pill--${statusTone}`}
            title={
              catalogDbActive && !saving && !dirty
                ? 'Catalog changes save automatically'
                : undefined
            }
          >
            <span className="admin-shell-top__pill-dot" aria-hidden />
            {statusLabel}
          </span>

          <button
            type="button"
            className="btn btn-primary btn-sm admin-shell-top__publish"
            onClick={onPublishCatalog}
            disabled={saving}
          >
            {saving ? 'Saving…' : dirty ? 'Publish now' : 'Publish'}
          </button>

          <div className="admin-shell-top__account">
            <span className="admin-shell-top__avatar" aria-hidden>
              {(adminUsername || 'A').charAt(0).toUpperCase()}
            </span>
            <span className="admin-shell-top__name">{adminUsername || 'admin'}</span>
            <button type="button" className="btn btn-link btn-sm admin-shell-top__signout" onClick={onLogout}>
              Sign out
            </button>
          </div>
        </div>
      </div>

      {showOffline ? (
        <p className="admin-shell-top__notice" role="status">
          Catalog is not loading from your live store. Open admin on your published website and refresh.
        </p>
      ) : null}
    </div>
  );
}
